import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      marginTop: '3rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      '@media (max-width: 1023px)': {
        height: (props: { showLegend: boolean }) =>
          props.showLegend ? 'auto' : '411px'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
